module.exports = __webpack_public_path__ + "static/img/shop_banner1@2x.49cd18d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/go/shop_banner1@2x.jpg
// module id = 96
// module chunks = 0